
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { computed, defineComponent, ref } from 'vue'
import { ColorEnum } from '../enums/color.enum'
import ExplainResultIconsList from './explain/explain-result-icons-list.component.vue'
import { DefaultImage } from './shared'
import CopyToClipboard from './shared/copy-to-clipboard.component.vue'
import { EpbBadge } from './shared/epb-badge'

export default defineComponent({
  name: 'ResultCard',
  components: {
    DefaultImage,
    EpbBadge,
    ExplainResultIconsList,
    CopyToClipboard,
  },
  props: {
    result: {
      type: Object as PropType<Result>,
    },
    messages: {
      type: Object,
    },
    errorDefaultImageBackgroundColor: {
      type: Boolean,
      default: () => false,
    },
    hoverDisabled: Boolean,
    selected: Boolean,
    hideScore: {
      type: Boolean,
      default: () => false,
    },
    isBoostedByAttribute: {
      type: Boolean,
      default: false,
    },
    isBuriedByAttribute: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const hovered = ref(false)

    const debugVisible = computed(() => !!props.result?.debug)

    return {
      baseClass: 'epb-result-card',
      hovered,
      debugVisible,
      ColorEnum,
    }
  },
})
